module.exports = __webpack_public_path__ + "media/images/author/author-5-db76f38bb328ae9051e1a747ceedb177.jpg";